import { Box, Typography, Button, TextField } from '@mui/material';

export default function MultipleChoiceQuestion({
  question,
  options,
  multiple = false,
  value,
  onChange,
  otherValue = '',
  onOtherChange,
}) {
  const isSelected = (optionValue) => {
    if (multiple) {
      return Array.isArray(value) && value.includes(optionValue);
    }
    return value === optionValue;
  };

  const handleSelect = (optionValue) => {
    if (multiple) {
      const current = Array.isArray(value) ? value : [];
      if (current.includes(optionValue)) {
        onChange(current.filter((v) => v !== optionValue));
      } else {
        onChange([...current, optionValue]);
      }
    } else {
      onChange(optionValue);
    }
  };

  return (
    <Box mb={2}>
      <Typography fontWeight={500} mb={1}>
        {question}{multiple ? ' (Select Multiple)' : ' (Select One)'}
      </Typography>
      <Box display="flex" flexWrap="wrap" alignContent="space-evenly" justifyContent="start" gap={1.5} alignItems="center">
        {options.map((option) => (
          <Box key={option.letter} display="flex" alignItems="center" gap={0.5} sx={{ flexBasis: 'calc(50% - 6px)' }}>
            <Button
              onClick={() => handleSelect(option.value)}
              variant={isSelected(option.value) ? 'contained' : 'outlined'}
              color="svceGreen"
              sx={{
                minWidth: 36,
                width: 36,
                height: 36,
                p: 0,
                borderColor: isSelected(option.value) ? 'primary.main' : 'grey.400',
                color: isSelected(option.value) ? 'common.white' : 'text.primary',
                fontWeight: 600,
                fontSize: '0.875rem',
                borderRadius: '4px',
              }}
            >
              {option.letter}
            </Button>
            {option.hasOtherInput ? (
              <Box display="flex" alignItems="center" gap={0.5}>
                <Typography variant="body2">{option.label}</Typography>
                <TextField
                  size="small"
                  variant="standard"
                  value={otherValue}
                  onChange={(e) => onOtherChange?.(e.target.value)}
                  sx={{ width: 120 }}
                  onClick={() => {
                    if (!isSelected(option.value)) handleSelect(option.value);
                  }}
                />
              </Box>
            ) : (
              <Typography variant="body2">{option.label}</Typography>
            )}
          </Box>
        ))}
      </Box>
    </Box>
  );
}
